import React, {useEffect, useState} from "react";
import {Box, Container, TextField, Typography} from "@mui/material";
import {IPostJobInput} from "../../models/inputs/PostJobInput";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {POST_JOB} from "../graphql/mutations/gqlPostJob";
import {toast} from "react-toastify";
import {createQueryParameterString, getQueryParameter} from "../../../../libraries/util/QueryParameterHelper";
import {LoaderForm} from "../loader-form/LoaderForm";
import {useNavigate} from "react-router-dom";
import {LoadingButton} from "@mui/lab";
import {GET_JOBS} from "../graphql/queries/gqlGetJobs";
import {GraphQlEditorButton} from "../graphql-editor/GraphQlEditorButton";
import {InputType} from "../../models/JobDefinition";
import {FilesCard} from "./Files";
import {TagsCard} from "../common/Tags";
import {ITag} from "../../models/Tag";
import {GET_JOB_DEFINITIONS} from "../graphql/queries/gqlGetJobDefinitions";

export const JobForm = () => {
	const jobDefinitionId: number = +(
		getQueryParameter("jobDefinitionId") ?? "0"
	);
	const jobId: number = +(
		getQueryParameter("jobId") ?? "0"
	);
	const navigate = useNavigate();
	
	const [data, setData] = useState<IPostJobInput>({
		description: "",
		graphQlQuery: "",
		id: jobId,
		jobDefinition: {id: 0, inputType: InputType.Anva, name: "", description: "", jobSteps: []},
		name: "",

	});
	const [loading, setLoading] = useState(true);
	const [loadingSubmit, setLoadingSubmit] = useState(false);
	
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setData({
			...data,
			[event.target.name]: event.target.value,
		});
	};
	
	const post = async () => {
		await graphQLServices.querytoolClient.mutate({
			mutation: POST_JOB,
			variables: {input: {
				...data,
				jobDefinition : jobDefinitionId
			}},
		});
	};
	
	const handleSubmit = (event: React.FormEvent) => {
		event.preventDefault();
		setLoadingSubmit(true);
		post()
			.then(() => {
				toast.success("Success");
				navigate(`/querytool/jobs${createQueryParameterString({
					jobDefinitionId,
				})}`);
			})
			.catch(() => toast.error("Failed 1"))
			.finally(() => setLoadingSubmit(false));
	};
	
	useEffect(() => {
		if (jobId) {
			graphQLServices.querytoolClient.query({
				query: GET_JOBS,
				variables: {
					"jobDefinitionId": jobDefinitionId,
					"where": {
						"and": {
							"id": {
								"eq": jobId
							}
						}
					}
				},
			})
				.then((result) => {
					setData({...data, ...result.data.jobs.nodes[0],
						tags: result.data.jobs.nodes[0].tags?.map((tag:ITag)=> {
							return {...tag, __typename:undefined};
						})
						, __typename: undefined});
				})
				.finally(() => setLoading(false));
		} else {
			graphQLServices.querytoolClient
				.query({
					query: GET_JOB_DEFINITIONS,
					variables: {
						"where": {
							"and": {
								"id": {
									"eq": jobDefinitionId,
								},
							},
						},
					},
				})
				.then((result) => {
					setData({...data,
						tags: result.data.jobDefinitions.nodes[0].tags?.map((tag:ITag) =>  {
							return {...tag, id:0, __typename: undefined};
						})
					});
				})
				.finally(() => setLoading(false));

		}
		// eslint-disable-next-line
	}, [jobId]);
	
	if (loading) {
		return (<LoaderForm title={"Post a Job"}/>);
	}
	
	console.info(JSON.stringify(data));
	const onChangeTags = (tags: ITag[] | undefined) => {
		setData({
			...data,
			tags : tags,
		});
	};
	
	return (
		<Container maxWidth="sm">
			<Box sx={{padding: 3}}>
				<Typography variant="h4" component="h1" align="left" gutterBottom>
					Job
				</Typography>
				
				<form onSubmit={handleSubmit}>
					<Box sx={{marginTop: 2}}>
						<LoadingButton loading={loadingSubmit} type="submit" fullWidth variant="contained">
							Submit
						</LoadingButton>
					</Box>
					<TextField
						fullWidth
						label="ID"
						name="id"
						value={data.id}
						onChange={handleChange}
						margin="normal"
						type="number"
						required
						disabled
					/>
					<TextField
						fullWidth
						label="Job Definition"
						name="jobDefinition"
						value={data.jobDefinition.name}
						onChange={handleChange}
						margin="normal"
						type="string"
						required
						disabled
					/>
					<TextField
						fullWidth
						label="Name"
						name="name"
						value={data.name}
						onChange={handleChange}
						margin="normal"
						required
					/>
					<TextField
						fullWidth
						label="Description"
						name="description"
						value={data.description}
						onChange={handleChange}
						margin="normal"
						required
					/>
					<TextField
						fullWidth
						label="Anva Sync Stage (optioneel)"
						name="anvaSyncStage"
						value={data.anvaSyncStage ?? ""}
						onChange={handleChange}
						margin="normal"
						helperText="Kan worden gebruikt om een alternatieve bron voor AnvaSync te gebruiken"
					/>
					<TextField
						fullWidth
						label="Anva Sync Account (optioneel)"
						name="anvaSyncAccount"
						value={data.anvaSyncAccount ?? ""}
						onChange={handleChange}
						margin="normal"
						helperText="Kan worden gebruikt om een alternatieve bron voor AnvaSync te gebruiken"
					/>

					{data.jobDefinition.inputType === InputType.Anva &&
						<GraphQlEditorButton
							query={data.graphQlQuery}
							setQuery={(query) => setData({...data, graphQlQuery: query})}
							anvaSyncStage={data.anvaSyncStage}
							anvaSyncAccount={data.anvaSyncAccount}
						/>
					}
					
				</form>
				<TagsCard tags={data.tags} onChangeTags={onChangeTags}/>
				<FilesCard id={jobId} type={"JOB"} allowUpload={true}/>
			</Box>
			
		</Container>
	);
};
